// extracted by mini-css-extract-plugin
export default {"wrapper":"B4-z","play":"C4-z"};